import { render, staticRenderFns } from "./2_m_information.vue?vue&type=template&id=7cdd3387&scoped=true&"
import script from "./2_m_information.vue?vue&type=script&lang=js&"
export * from "./2_m_information.vue?vue&type=script&lang=js&"
import style0 from "./2_m_information.vue?vue&type=style&index=0&id=7cdd3387&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdd3387",
  null
  
)

export default component.exports